export const environment = {
  production: true,
  backendServer: "https://ecoenvai.ijs.si/radiant/bm-dss/"
};
